var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import TableHead from './table-head';
import TableRow from './table-row';
export var CellAlign;
(function (CellAlign) {
    CellAlign["LEFT"] = "left";
    CellAlign["CENTER"] = "center";
    CellAlign["RIGHT"] = "right";
})(CellAlign || (CellAlign = {}));
export var CellType;
(function (CellType) {
    CellType["TEXT"] = "text";
    CellType["NUMBER"] = "number";
    CellType["NUMBERING"] = "numbering";
    CellType["STATUS"] = "status";
    CellType["IMAGE"] = "image";
    CellType["IMAGE_WITH_TEXT"] = "image-with-text";
    CellType["METADATA"] = "metadata";
    CellType["SHRED_PREVIEW"] = "shrew-preview";
    CellType["PRICE"] = "price";
    CellType["ACTION"] = "action";
})(CellType || (CellType = {}));
export default function Table(_a) {
    var labels = _a.labels, rows = _a.rows, actions = _a.actions, notRounded = _a.notRounded, selectedRowIds = _a.selectedRowIds, selectRow = _a.selectRow, shiftSelectRow = _a.shiftSelectRow, selectAllRows = _a.selectAllRows;
    var t = useI18n().t;
    return (_jsxs(Container, { notRounded: notRounded, children: [_jsx(TableHead, { labels: labels, selectAllRows: selectAllRows }), rows.map(function (row, index) { return (_jsx(TableRow, { actions: actions, index: index, labels: labels, row: row, selectRow: selectRow ? function () { return selectRow(index); } : undefined, selected: selectedRowIds ? selectedRowIds.includes(row.id) : undefined, shiftSelectRow: shiftSelectRow ? function () { return shiftSelectRow(index); } : undefined }, index)); }), rows.length === 0 && (_jsx(NoResultRow, { children: _jsx("p", { children: t('common.no-result') }) }))] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n  width: 100%;\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutCard;
}, function (_a) {
    var notRounded = _a.notRounded, theme = _a.theme;
    return (notRounded ? 'none' : "solid 1px ".concat(theme.palette.layoutCardStroke));
}, function (_a) {
    var notRounded = _a.notRounded;
    return (notRounded ? '0' : '12px');
});
var NoResultRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.33);\n  display: flex;\n  flex-direction: row;\n  height: 96px;\n  justify-content: center;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400px;\n  }\n"], ["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.33);\n  display: flex;\n  flex-direction: row;\n  height: 96px;\n  justify-content: center;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400px;\n  }\n"])));
var templateObject_1, templateObject_2;
